import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import { useQuery } from '@apollo/react-hooks';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Moment from 'react-moment';
import './styles/crosssection-dialog.scss';
import { GET_CROSSSECTION_DATA } from './queries/dialog.queries';

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
  },
  root: {

  },
  tabPanel: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  contentArea: {
    minHeight: "300px",
    maxHeight: "300px",
  },
  tableCell: {
    width: "100px"
  }
}));

const CrosssectionDetailDialog = ({
    crosssectionId, crosssectionName, open, onClose
}) => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    function a11yProps(index) {
      return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
      };
    }

    function TabPanel(props) {
      const { children, value, index, ...other } = props;
      return (
        <Typography
          component="div"
          role="tabpanel"
          hidden={value !== index}
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
          {...other}
        >
          <div className={classes.tabPanel}>{children}</div>
        </Typography>
      );
    }

    return (
      <Dialog 
        className={classes.root}
        scroll="paper"
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}maxWidth="md"
        fullWidth={true}
        open={open}
        onClose={onClose}>
        <AppBar position="static" color="primary">
          <Toolbar>
            <Typography variant="h5" className={classes.title}>
              {crosssectionName}
            </Typography>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={onClose}>
              <CloseIcon />
           </IconButton>
          </Toolbar>
        </AppBar>
        <AppBar position="static" color="default">
          <Tabs value={value} onChange={handleChange} aria-label="crosssection detail dialog tabs">
            <Tab label="Live-Daten" {...a11yProps(0)} />
          </Tabs>
        </AppBar>
        <DialogContent className={classes.contentArea}>
          <TabPanel classes={classes} value={value} index={0}>
            <LiveDataTable crosssectionId={crosssectionId} />
          </TabPanel>
        </DialogContent>
        <Divider></Divider>
      </Dialog>
    );
};

const LiveDataTable = props => {
  const { crosssectionId } = props;
  const { data } = useQuery(GET_CROSSSECTION_DATA, {variables: { id: crosssectionId }});
  
  let trafficData = {
    qKfzG: -4, qLkwG: -4, qPkwG: -4,
    vKfzG: -4, vLkwG: -4, vPkwG: -4
  };

  if(data !== undefined) {
    trafficData = data.crosssection.traffic_data;
    
    if(trafficData == null) {
        return null;
    }

    return (
      <Table size="small" className="trafficDataTable">
        <TableBody>
          <TableRow>
            <TableCell className="tableCell">qKfz</TableCell>
            <TableCell className="tableCell" align="right">{trafficData.qKfzG === -4 ? "N/A" : trafficData.qKfzG + " Fz/h"}</TableCell>
            <TableCell className="tableCell"><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="tableCell">qLkw</TableCell>
            <TableCell className="tableCell" align="right">{trafficData.qLkwG === -4 ? "N/A" : trafficData.qLkwG + " Fz/h"}</TableCell>
            <TableCell className="tableCell"><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="tableCell">qPkw</TableCell>
            <TableCell className="tableCell" align="right">{trafficData.qPkwG === -4 ? "N/A" : trafficData.qPkwG + " Fz/h"}</TableCell>
            <TableCell className="tableCell"><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="tableCell">vKfz</TableCell>
            <TableCell className="tableCell" align="right">{trafficData.vKfzG === -4 ? "N/A" : trafficData.vKfzG + " km/h"}</TableCell>
            <TableCell className="tableCell"><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="tableCell">vLkw</TableCell>
            <TableCell className="tableCell" align="right">{trafficData.vLkwG === -4 ? "N/A" : trafficData.vLkwG + " km/h"}</TableCell>
            <TableCell className="tableCell"><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="tableCell">vPkw</TableCell>
            <TableCell className="tableCell" align="right">{trafficData.vPkwG === -4 ? "N/A" : trafficData.vPkwG + " km/h"}</TableCell>
            <TableCell className="tableCell"><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  } else {
    return null;
  }
};

CrosssectionDetailDialog.propTypes = {
  crosssectionName: PropTypes.string.isRequired,
  crosssectionId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default CrosssectionDetailDialog;